// 인풋 스타일

import classNames from "classnames";
import { InputHTMLAttributes, useRef } from "react";

type InputVariant = "";
type InputRole = "C" | "R" | "U";

export type Ref = HTMLInputElement;

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  type?: string;
  name: string;
  variant?: InputVariant;
  dataTyp?: InputRole;
  fullWidth?: boolean;
  validatyTxt?: string;
}

const Input = ({
  type = "text",
  className = "",
  variant,
  dataTyp = "C",
  fullWidth,
  validatyTxt,
  ...rest
}: InputProps) => {
  const ref = useRef<HTMLInputElement>(null);
  const inputClass = classNames(
    `${className} ${fullWidth ? "w-full" : "w-auto"}`
  );

  return (
    <>
      <input
        type={type}
        ref={ref}
        className={inputClass}
        data-type={dataTyp}
        autoComplete="off"
        onInvalid={(e) => e.currentTarget.setCustomValidity(validatyTxt ?? "")}
        onInput={(e) => e.currentTarget.setCustomValidity("")}
        {...rest}
      />
    </>
  );
};

export default Input;
